function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11c3 0 5.5-2.5 5.5-5.5S16.5 0 13.5 0 8 2.5 8 5.5c0 .7.1 1.4.4 2.1L1 15l4 4 2.1-2.1L5.2 15l.9-.9L7.9 16l2.1-2.1-1.8-1.8 2.1-2.1c.9.6 2 1 3.2 1zM16 4.5c0 .8-.7 1.5-1.5 1.5S13 5.3 13 4.5 13.7 3 14.5 3s1.5.7 1.5 1.5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgKey;